const EXPORT_STATUS = {
  WORKING: 'WORKING',
  DONE: 'DONE',
  FAIL: 'FAIL',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const EXPORT_STATUS_ENUM = Object.keys(EXPORT_STATUS);

export {
  EXPORT_STATUS,
  EXPORT_STATUS_ENUM,
};
